import { render } from "./Axis.vue?vue&type=template&id=3296bb30"
import script from "./Axis.vue?vue&type=script&lang=js"
export * from "./Axis.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__